<section class="modal">
  <div class="modal-header header pt-15 plr-20 pb-5">
    <app-header-actions-contract-list
      class="vw-100"
      (searchFieldsEvent)="searchFields($event)"></app-header-actions-contract-list>
  </div>

  <div class="modal-body body p-15">

    <div class="content-search search d-flex align-top">

      <div class="d-flex align-center">
        <input
          class="search-field"
          type="text"
          placeholder="Buscar (Nº do contrato, CNPJ beneficiário)"
          [formControl]="queryField"
          (change)="handleSearchField(queryField.value)"
          (keyup.enter)="handleSearchField(queryField.value)"
          style="width: 420px" />

        <app-svg-icon
          class="search-icon"
          width="15px"
          height="17px"
          src="assets/icons/search-icon.svg"
          alt="search">
        </app-svg-icon>
      </div>

      <div class="search-date date d-flex direction-column plr-15 ml-25">
        <span class="d-flex date-title">Data do Faturamento</span>

        <div class="d-flex column-gap-5 pb-15 align-center">
          <label class="lb-date" [attr.for]="invoiceDateFromInput.inputId">Inicio: </label>
          <app-c-input
            #invoiceDateFromInput
            [formControl]="invoiceDateFrom"
            inputType="date"
            class="form-input flex-1">
          </app-c-input>

          <label class="lb-date" [attr.for]="invoiceDateToInput.inputId">Fim: </label>
          <app-c-input
            #invoiceDateToInput
            [formControl]="invoiceDateTo"
            inputType="date"
            class="form-input flex-1">
          </app-c-input>

        </div>
      </div>

    </div>


    <app-ordered-contract-list
      [contracts]="contracts"
      (orderChangeEvent)="orderChange($event)">
      <ng-container footer>
        <ng-container *ngIf="count > contracts.length">
          <app-scroll-pagination
            [count]="count"
            [isModal]="true"
            minWidth="1120"
            (viewMoreTrigger)="handlePagination($event)"></app-scroll-pagination>
        </ng-container>
      </ng-container>
    </app-ordered-contract-list>

  </div>

  <div class="modal-footer">
    <app-footer-contract-list
      (addContractsEvent)="handleInsertContracts()"
      (closeModalEvent)="closeModal()"></app-footer-contract-list>
  </div>
</section>